export const alphabeticalSorting = (dataArray) => {
  const dataArrayCpy = [...dataArray];

  dataArrayCpy.sort((firstElement, secondElement) => {
    if (dataArray[0][1].adminPromotorId) return;

    const nameFirst = firstElement[0].clientName
      ? firstElement[0].clientName
      : firstElement[0];
    const nameSecond = secondElement[0].clientName
      ? secondElement[0].clientName
      : secondElement[0];

    if (nameFirst < nameSecond) {
      return -1; // nameFirst comes before nameSecond
    } else if (nameFirst > nameSecond) {
      return 1; // nameFirst comes after nameSecond
    } else {
      return 0; // names are equal
    }
  });
  return dataArrayCpy;
};

export function sortAndGroupRefunds(records) {
  // Step 1: sort by createdAt (ascending here, change to descending if needed)
  records.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  // Step 2: group by ownerEmail
  const grouped = [];
  const visited = new Set();

  for (const rec of records) {
    if (visited.has(rec.email)) continue;

    // Find the "root" record: email === ownerEmail
    const root = records.find(
      (r) => r.email === r.ownerEmail && r.email === rec.ownerEmail
    );
    if (root && !visited.has(root.email)) {
      grouped.push(root);
      visited.add(root.email);
    }

    // Add all children (records whose ownerEmail === root.email)
    const children = records.filter(
      (r) => r.ownerEmail === (root ? root.email : rec.ownerEmail)
    );
    for (const child of children) {
      if (!visited.has(child.email)) {
        grouped.push(child);
        visited.add(child.email);
      }
    }
  }

  return grouped;
}